import { Component, OnInit, inject } from '@angular/core';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { PageTitleService } from '../../core/services/page-title.service';
import { CounselService } from '../../core/services/counsel.service';

@Component({
    selector: 'app-program-item',
    imports: [],
    template: `
    <div class="animated fadeIn">
      <div class="row sfapp-container">
        @if (pdfUrl) {
          <embed width="100%" height="1000px" type="application/pdf" [src]="pdfUrl">
        }
      </div>
    </div>
  `
})
export class ProgramItemComponent implements OnInit {
  private pageTitle = inject(PageTitleService);
  private counselService = inject(CounselService);
  private sanitizer = inject(DomSanitizer);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  pdfUrl: SafeResourceUrl | null = null;

  async ngOnInit(): Promise<void> {
    this.pageTitle.set('', 'プログラム');
    const uploadedPdf = this.route.snapshot.params['uploadedPdf'];
    if (!uploadedPdf) { this.router.navigate(['/program']); return; }
    const result = await this.counselService.getTrainingPdf(uploadedPdf);
    if (result?.data) {
      const blob = new Blob([new Uint8Array(result.data)], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
  }
}
